import * as React from "react";
import Menu from "@mui/material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  SwipeableDrawer,
  Toolbar,
  Tooltip,
  Typography,
  TooltipProps,
  tooltipClasses,
  Grid,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation } from "react-router-dom";
import HmisLogo from "../../components/CustomButton/HmisLogo/HmisLogo";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import "./PrivacyAndPolicy.scss";
import Title from "../../components/Title";

const drawerWidth = 360;
const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: "0.15s",
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: "0.15s",
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// =============END Drawar============================

export default function Nav(props: any) {
  function scrollFunction1() {
    setState({ left: false });
    let e: any = document.getElementById("el1");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction2() {
    setState({ left: false });
    let e: any = document.getElementById("el2");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction3() {
    setState({ left: false });
    let e: any = document.getElementById("el3");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction4() {
    setState({ left: false });
    let e: any = document.getElementById("el4");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction5() {
    setState({ left: false });
    let e: any = document.getElementById("el5");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction6() {
    setState({ left: false });
    let e: any = document.getElementById("el6");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction7() {
    setState({ left: false });
    let e: any = document.getElementById("el7");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction8() {
    setState({ left: false });
    let e: any = document.getElementById("el8");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction9() {
    setState({ left: false });
    let e: any = document.getElementById("el9");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction10() {
    setState({ left: false });
    let e: any = document.getElementById("el10");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction11() {
    setState({ left: false });
    let e: any = document.getElementById("el11");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction12() {
    setState({ left: false });
    let e: any = document.getElementById("el12");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction13() {
    setState({ left: false });
    let e: any = document.getElementById("el13");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction14() {
    setState({ left: false });
    let e: any = document.getElementById("el14");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction15() {
    setState({ left: false });
    let e: any = document.getElementById("el15");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction16() {
    setState({ left: false });
    let e: any = document.getElementById("el16");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
  function scrollFunction17() {
    setState({ left: false });
    let e: any = document.getElementById("el17");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  const theme = useTheme();
  const matches = useMediaQuery("(max-width:1024px)");
  const smallScreen = useMediaQuery("(max-width:767px)");

  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const spanRef = React.useRef(null);

  const [state, setState] = React.useState({ left: false });

  const [ThemeNew, setThemeNew] = React.useState(props.colorScheme);
  const ColorModeContext = React.createContext({
    toggleColorMode: () => {
      props.changeMode(ThemeNew === "light" ? "dark" : "light");
      setThemeNew(ThemeNew === "light" ? "dark" : "light");
    },
  });
  const open4 = Boolean(anchorEl4);
  type Anchor = "top" | "left" | "bottom" | "right";
  const toggleDrawer =
    (anchor: any, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      //
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      let page = event !== undefined ? event.target.innerText : null;
      setNewOpen(true);
      setState({ ...state, [anchor]: open });
    };

  // =====================================================
  // const theme = useTheme();
  // ------------------------
  const [openNew, setNewOpen] = React.useState(true);

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#25258f",
    },
  }));

  // mobile devices
  const list = (anchor: Anchor) => (
    <List>
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          marginTop: "2px",
          marginLeft: "20px",
          marginBottom: "7px",
        }}
      >
        <HmisLogo className="logo" size={45} />
      </Box>
      <Divider />
      <span className="terms-side-menu-mobile">
        <span className="terms-side-menu-mobile-line-height">
          <ol
            style={{
              paddingLeft: "30px",
              margin: 0,
            }}
          >
            <li>
              <Typography onClick={scrollFunction1} className="left-buttons">
                BASIC TERMS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction2} className="left-buttons">
                INTELLECTUAL PROPERTY RIGHTS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction3} className="left-buttons">
                DISCLAIMERS AND WARRANTIES
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction4} className="left-buttons">
                PERFORMANCE OF THE WEBSITE AND APPLICATIONS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction5} className="left-buttons">
                THIRD PARTY LINKS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction6} className="left-buttons">
                COOKIE POLICY AND USE OF TRACKING
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction7} className="left-buttons">
                NOTICE FOR TERMINATION AND REMEDIES
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction8} className="left-buttons">
                WAIVER AND ENFORCEABILITY
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction9} className="left-buttons">
                USAGE OF PERSONAL DATA
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction10} className="left-buttons">
                BLOG / FORUM
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction11} className="left-buttons">
                SECURITY OF YOUR APPLICATION AND PERSONAL DATA
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction12} className="left-buttons">
                OVERSEAS DISCLOSURE OF YOUR DATA
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction13} className="left-buttons">
                DATA RETENTION
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction14} className="left-buttons">
                JURISDICTION AND GOVERNING LAWS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction15} className="left-buttons">
                PERSONAL INFORMATION OF MINORS
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction16} className="left-buttons">
                SALE OF PERSONAL INFORMATION
              </Typography>
            </li>
            <li>
              <Typography onClick={scrollFunction17} className="left-buttons">
                QUERIES, CONCERNS, AND COMPLAINTS
              </Typography>
            </li>
          </ol>
        </span>
      </span>
    </List>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Title pageTitle="VISTAMED - Privacy Policy" />
      <AppBar position="static" className="app-bar" enableColorOnDark>
        <Toolbar
          sx={{
            padding: !matches ? "0px !important" : "",
            border: "1px solid #e9e9ef",
            position: matches ? "fixed" : "",
            backgroundColor: matches ? "#fff" : "",
            width: "100%",
          }}
        >
          {matches ? (
            // For Mobile
            <>
              <IconButton
                color="primary"
                aria-label="open drawer"
                onClick={toggleDrawer("left", true)}
                edge="start"
                sx={{
                  marginRight: 5,
                }}
              >
                <MenuIcon />
              </IconButton>
              <Box sx={{ width: "2em" }} component="span" ref={spanRef}>
                <Menu
                  className="main-profie-container"
                  anchorEl={anchorEl4}
                  open={open4}
                  sx={{ maxWidth: "329px !important" }}
                  onClose={() => profileClose("")}
                  MenuListProps={{
                    "aria-labelledby": "basic-button3",
                  }}
                ></Menu>
              </Box>
            </>
          ) : (
            <>
              <Grid sx={{ width: "100%", padding: "0px !important" }}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    padding: "0px !important",
                  }}
                >
                  <Drawer
                    variant="permanent"
                    open={openNew}
                    style={{ transitionDuration: "0.15s" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        py: 2, // top & bottom padding
                      }}
                    >
                      <HmisLogo className="logo" size={45} />
                    </Box>
                    <Divider />
                    {/* <DrawerHeader /> */}
                    <List>
                      <span className="terms-side-menu-web">
                        <span>
                          {/* //----------------------------------                                                     */}
                          <ol
                            style={{
                              paddingLeft: "30px",
                              margin: 0,
                            }}
                          >
                            <li>
                              <ListItem
                                key={"DEFINITIONS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction1}
                                  className="left-buttons"
                                >
                                  BASIC TERMS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"DESCRIPTION"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction2}
                                  className="left-buttons"
                                >
                                  INTELLECTUAL PROPERTY RIGHTS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"ACCOUNTTERMS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction3}
                                  className="left-buttons"
                                >
                                  DISCLAIMERS AND WARRANTIES
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"ACCEPTABLEUSE"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction4}
                                  className="left-buttons"
                                >
                                  PERFORMANCE OF THE WEBSITE <br></br>AND
                                  APPLICATIONS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"SERVICEPERIOD"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction5}
                                  className="left-buttons"
                                >
                                  THIRD PARTY LINKS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"PAYMENT"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction6}
                                  className="left-buttons"
                                >
                                  COOKIE POLICY AND USE OF TRACKING
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"CANCELLATIONANDTERMINATION"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction7}
                                  className="left-buttons"
                                >
                                  NOTICE FOR TERMINATION AND REMEDIES
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"SERVICECOMMITMENTANDSUPPORT"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction8}
                                  className="left-buttons"
                                >
                                  WAIVER AND ENFORCEABILITY
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"NONUSE AND NONDISCLOSURE"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction9}
                                  className="left-buttons"
                                >
                                  USAGE OF PERSONAL DATA
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"CUSTOMERDATA"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction10}
                                  className="left-buttons"
                                >
                                  BLOG / FORUM
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"INTELLECTUALPROPERTY"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction11}
                                  className="left-buttons"
                                >
                                  SECURITY OF YOUR APPLICATION <br></br>AND
                                  PERSONAL DATA
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"LIMITATIONSOFLIABILITY"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction12}
                                  className="left-buttons"
                                >
                                  OVERSEAS DISCLOSURE OF YOUR DATA
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"REPRESENTATIONSANDINDEMNITIES"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction13}
                                  className="left-buttons"
                                >
                                  DATA RETENTION
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"MISCELLANEOUS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction14}
                                  className="left-buttons"
                                >
                                  JURISDICTION AND GOVERNING LAWS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"MISCELLANEOUS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction15}
                                  className="left-buttons"
                                >
                                  PERSONAL INFORMATION OF MINORS
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"MISCELLANEOUS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction16}
                                  className="left-buttons"
                                >
                                  SALE OF PERSONAL INFORMATION
                                </Typography>
                              </ListItem>
                            </li>
                            <li>
                              <ListItem
                                key={"MISCELLANEOUS"}
                                disablePadding
                                className={"terms-nav-ListItemButton"}
                                sx={{ display: "block" }}
                              >
                                <Typography
                                  onClick={scrollFunction17}
                                  className="left-buttons"
                                >
                                  QUERIES, CONCERNS, AND COMPLAINTS
                                </Typography>
                              </ListItem>
                            </li>
                          </ol>
                        </span>
                      </span>
                    </List>
                  </Drawer>
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      minHeight: "100vh",
                      position: "relative",
                    }}
                  >
                    {/* <DrawerHeader id="drwerheader" /> */}
                    <Box className="terms-and-conditions-right-side">
                      <Box className="title-bottom-border">
                        <h1>Privacy Policy</h1>
                      </Box>
                      <Box sx={{ paddingTop: "30px" }}>
                        Effective from - Sep 19, 2023
                      </Box>
                      <br />
                      <Box>
                        <p>
                          The privacy policy is based on all the
                          products/services that are being provided and dealt
                          with by PEDIAVERSE to their existing customers.
                          However the same shall also be applicable for any
                          and/or all the products/services that are provided to
                          the customers of PEDIAVERSE in the future based on the
                          development, software updates, market trends, etc.
                        </p>
                        <p>
                          You are therefore required to go through all the terms
                          and conditions as mentioned hereunder based on which
                          you may make your decision to continue or discontinue
                          your venture with PEDIAVERSE. Upon acceptance of the
                          said document it shall be understood by PEDIAVERSE
                          that you have unconditionally accepted any and/or all
                          the terms and conditions as mentioned hereunder and
                          that you have and shall not raise any contradiction,
                          legal issues, questions, queries, etc. about the same
                          for all points of time in the future and that
                          PEDIAVERSE shall not be liable under any set of
                          circumstances either to you and/or your subordinates,
                          sister companies, third parties associated with your,
                          either directly and/or indirectly for any amounts
                          including any charges, fees, payments, duties, costs,
                          etc. Further, it must be clearly noted, understood and
                          accepted by you that upon breach of any of the terms
                          and conditions as mentioned hereunder PEDIAVERSE shall
                          have any and/or all the legal right(s) to be initiated
                          against you personally or your organization and/or any
                          other person(s) either associated and/or connected
                          with you either directly and/or indirectly and that
                          such persons shall be jointly and severally be liable
                          for the costs and consequences arising out of such
                          legal actions which may be in the form of Civil and/or
                          Criminal remedies including the costs, expenses as
                          well as lawyer’s fees; which may be clearly understood
                          by you.
                        </p>
                        <p>The terms and conditions as mentioned as follows:</p>
                        <Box id="el1" className="title">
                          <h4>A. BASIC TERMS</h4>
                        </Box>
                        <p>
                          It will be your responsibility to ensure the security
                          and confidentiality of usernames and passwords which
                          will be used to access this website. Any breach,
                          compromise or unauthorised use should be immediately
                          notified to PEDIAVERSE.
                        </p>
                        <p>
                          The security or integrity of the computing system,
                          network and the website of PEDIAVERSE shall not be
                          compromised in any way by you as well as the
                          organisation in which you are associated.
                        </p>
                        <p>
                          Must not use any form of abuse over the Website and/or
                          Applications or other software products of PEDIAVERSE
                          in any form or way that will adversely impact the
                          functionality of the website or the ability of any
                          user to use the website of PEDIAVERSE. No kind of any
                          derogatory remarks shall be made by you as mentioned
                          above.
                        </p>
                        <p>
                          Any type of activity resulting in unauthorized access
                          to the computer system on server of the website or to
                          any materials other than those to which access or
                          permission has been granted will amount to a violation
                          or a breach of the policy.
                        </p>
                        <p>
                          Any type of act resulting in transmission of files,
                          contents that may be offensive, materials, data in
                          violation of any laws of the land (included materials
                          protected by copyright or trade secrets which
                          restricts the right to use it) in the website,
                          damaging any other person’s computing devices or
                          software will be amount to a violation or a breach of
                          the policy.
                        </p>
                        <p>
                          Any act resulting in modifying, copying, adapting,
                          editing, reproducing, disassembling, decompiling or
                          reverse engineering the website or the applications of
                          the Company, except as is strictly necessary to use
                          for formal operation will be regarded as a violation
                          or a breach of the policy.
                        </p>
                        <p>
                          The website of the Company; i.e. PEDIAVERSE; should be
                          accessed manually. Any act resulting into usage of
                          automated agents, software other than the search
                          engine to view the website is forbidden
                        </p>
                        <p>
                          If you use any communication tools available through
                          the Website of the Company such as Blogs, support
                          portals, messaging centre, you unconditionally agree
                          to use such communication tools for lawful and
                          legitimate purposes only. You must not use these tools
                          to post offensive content, any material in violation
                          of intellectual property rights or any offers of goods
                          or services for sale.
                        </p>

                        <Box id="el2" className="title">
                          <h4>B. INTELLECTUAL PROPERTY RIGHTS</h4>
                        </Box>
                        <p>
                          The Intellectual Property Rights in all the
                          constituents comprising the website including the
                          structure, design &layout including graphical images
                          along with the applied source codes vests with
                          PEDIAVERSE.
                        </p>
                        <p>
                          It is recognized that all the Intellectual Property
                          Rights of PEDIAVERSE portal, the website as well as
                          all the computer aided or mobile aided applications;
                          shall vest with PEDIAVERSE.
                        </p>
                        <p>
                          No kind of any royalty-free, perpetual, irrevocable,
                          non-exclusive right and license is granted to any of
                          the Customers to use, reproduce, modify, adapt,
                          publish, translate, create, derivative work from,
                          distribute, communicate, perform and display the
                          content, in whole or in part, worldwide and to
                          incorporate it in other works in any form, media or
                          technology knows or later developed for full term of
                          any rights that may exist by submitting any blogs,
                          messages boards or forums of PEDIAVERSE.
                        </p>
                        <p>
                          You shall not provide any content to PEDIAVERSE that
                          does not belong to you or if you do not have the
                          intellectual property rights for that content.
                        </p>
                        <p>
                          Building or Copying or encrypting any of the data
                          PEDIAVERSE will be a breach of our intellectual
                          property.
                        </p>
                        <Box id="el3" className="title">
                          <h4>C. DISCLAIMERS AND WARRANTIES</h4>
                        </Box>
                        <p>
                          You fully acknowledge to the Company the following:
                        </p>
                        <p>
                          That you are authorised to access and use the Website.
                        </p>
                        <p>
                          That in case you are using the website on behalf of
                          any organization, you would still be liable for your
                          actions along with the organization for any breach of
                          terms.
                        </p>
                        <p>
                          The provision of, access to, and use of, the Website
                          is on an “as is, where is” basis and at your own risk.
                        </p>
                        <p>
                          t is not guaranteed that the website or the
                          applications of PEDIAVERSE will be error free and that
                          PEDIAVERSE will not be responsible for any disruptions
                          caused due to any applications, gadgets including
                          internet services used by yourself to access the
                          website. No kind of damages and/or losses shall be
                          cast upon PEDIAVERSE based on the non-performance of
                          any of their websites and/or applications for any
                          reasons of whatsoever nature.
                        </p>
                        <p>
                          It shall be your sole responsibility to determine that
                          the Website or the applications of PEDIAVERSE meets
                          the needs of your business. No kind of repayment
                          and/or refund shall be made by PEDIAVERSE under any
                          set of circumstances, reasons, technical hitches, etc.
                          of whatsoever nature which may be claimed by you.
                        </p>
                        <p>
                          Without limiting the foregoing, PEDIAVERSE does not
                          warrant that their Website as well as their
                          applications will meet your requirements or that it
                          will be suitable for your purposes.{" "}
                        </p>
                        <p>
                          To avoid doubt, all implied conditions or warranties
                          are excluded in so far as is permitted by law
                          including, without limitation, warranties of
                          merchantability, fitness for purpose, title and
                          non-infringement.
                        </p>
                        <Box id="el4" className="title">
                          <h4>
                            D. PERFORMANCE OF THE WEBSITE AND APPLICATIONS
                          </h4>
                        </Box>
                        <p>
                          PEDIAVERSE denies all liability for the timely
                          operation of the Website or any of its applications
                          when used within an Internet environment, where you or
                          a third party is providing the computer equipment upon
                          which the product is to reside or depend upon for any
                          part of its functionality.
                        </p>
                        <p>
                          By accepting these Terms you confirm your
                          understanding that the timely operation of the
                          Internet and the World Wide Web is governed by
                          constraints beyond the control of PEDIAVERSE and that
                          it is not liable for the perceived slow operation of
                          the Website or any of its applications.
                        </p>
                        <p>
                          The client must maintain a copy of all their data
                          inputted into the website or the applications of
                          PEDIAVERSE who although shall take a regular backup of
                          all the data but however does not guarantee that there
                          will no loss of data. PEDIAVERSE excludes liability
                          for any loss of data no matter how it was caused.
                        </p>
                        <p>
                          To the maximum extent permitted by law, PEDIAVERSE
                          excludes all liability and responsibility to you (or
                          any other person) in contract, tort (including
                          negligence), or otherwise, for any loss (including
                          loss of information, Data, profits and savings) or
                          damage resulting, directly or indirectly, from any use
                          of, or reliance on, the Service or Website or
                          applications.
                        </p>
                        <Box id="el5" className="title">
                          <h4>E. THIRD PARTY LINKS</h4>
                        </Box>
                        <p>
                          This Privacy Policy applies only to the use and
                          disclosure of Personal Data that is collected by
                          PEDIAVERSE.
                        </p>
                        <p>
                          Provision of a link to any other website or location
                          is for your convenience and does not signify our
                          endorsement of such other website or location or its
                          contents.
                        </p>
                        <p>
                          When you click on such a link, you will leave the
                          Services of PEDIAVERSE available on wither its website
                          and/or its applications and would go to another site.
                          During this process, a third party may collect
                          Personal Data from you. PEDIAVERSE has no control
                          over, dose not review, dose not endorse, and cannot be
                          responsible for, these outside websites or their
                          content.
                        </p>
                        <p>
                          You may thus be fully aware that the terms of this
                          Privacy Policy do not apply to these outside websites
                          or content, or to any collection of data after you
                          click on a link to a third party. In case of
                          submission of any Personal Data by you to any of those
                          sites, your information is governed by their privacy
                          policies.
                        </p>
                        <Box id="el6" className="title">
                          <h4>F. COOKIE POLICY AND USE OF TRACKING</h4>
                        </Box>
                        <p>
                          Upon any interaction over the Website or the
                          Applications of PEDIAVERSE, an effort is made for
                          accessing and using the same in a simple manner by
                          PEDIAVERSE so that the contents mentioned therein are
                          easily understood by the Client/Customer.
                        </p>
                        <p>
                          PEDIAVERSE as well as other such organizations use
                          industry standard identifiers, such as cookies or
                          other similar technologies wherein the term cookies,
                          web beacons, flash cookies and pixels would be
                          collectively referred as “cookies”, “tracking
                          technology” or “identifiers” in this policy. By using
                          our Services, you are unconditionally agreeing that
                          PEDIAVERSE can use cookies and other tracking
                          technologies described in this Cookie Policy.
                        </p>
                        <Box id="el7" className="title">
                          <h4>G. NOTICE FOR TERMINATION AND REMEDIES</h4>
                        </Box>
                        <p>
                          PEDIAVERSE reserves the right to cancel your contract
                          or restrict your access to any of the websites as well
                          as applications of PEDIAVERSE without any prior notice
                          in any unlikely event of a breach of this contract.
                        </p>
                        <p>
                          In case of any legal dispute PEDIAVERSE shall be
                          entitled to share your user details, data, passwords,
                          identity and/or any other information; if requested by
                          the court or any other law enforcement authorities or
                          agencies.
                        </p>
                        <p>
                          Your data will be retained on our database for period
                          of 90 days from the expiry date of your subscription.
                          After this time period all your data will be purged
                          from the database of PEDIAVERSE.
                        </p>
                        <p>
                          Noncompliance with any of the terms and conditions as
                          mentioned hereinabove shall lead to an immediate
                          termination of the services from either of the parties
                          to the other. However, in case where an error and/or
                          dispute can be resolved, a prior intimation for the
                          same shall be sent by the party affected to the other
                          who shall try to resolve the same at the immediate and
                          earliest possible date and to the best of their
                          abilities. Such intimation can be given by the party
                          affected to the other over the email and/or through a
                          registered post only. No kind of intimation over any
                          of the communicating applications shall be valid.
                        </p>
                        <p>
                          If you are not satisfied with the Services of
                          PEDIAVERSE, your sole and exclusive remedy is to
                          terminate these Terms.
                        </p>
                        <Box id="el8" className="title">
                          <h4>H. WAIVER AND ENFORCEABILITY</h4>
                        </Box>
                        <p>
                          Any failure or delay by PEDIAVERSE to enforce any of
                          the terms or to exercise any right under the terms
                          will not be considered as a waiver to any extent of
                          any other rights as per the Law that are available to
                          PEDIAVERSE.
                        </p>
                        <p>
                          If either party waives any breach of these terms in
                          entire agreement, this will not constitute a waiver of
                          any other breach. No waiver will be effective unless
                          made in writing.
                        </p>
                        <Box id="el9" className="title">
                          <h4>I. USAGE OF PERSONAL DATA</h4>
                        </Box>
                        <p>
                          The data used, shared, transferred or downloaded by
                          the Client shall be used by PEDIAVERSE in the
                          following manner:
                        </p>
                        <p>
                          For creating your account on our network and securing
                          the same and to recognise your identity.
                        </p>
                        <p>
                          For administering and improving the services provided
                          by PEDIAVERSE including updates, advertisements, email
                          communications, chat and its notifications, security
                          and support, payment gateways, resolution of issues,
                          bugs, errors, interactive interface, surveys, events
                          or promotions, data analysis, notices, changes as well
                          as updatation in the terms of the Policy legal
                          processes, discontinuation of services, etc..
                        </p>
                        <p>
                          For prevention of any unlawful, unethical, illegally
                          actionable and/or fraudulent activity.
                        </p>
                        <p>
                          For monitoring and enforcement of compliance with the
                          applicable Terms of mentioned in the Policy document.
                        </p>
                        <p>
                          The feedback provided by you would be stored,
                          analysed, discussed and used for our internal
                          administration in order to further assist you in
                          providing our services through our website as well as
                          applications.
                        </p>
                        <p>
                          Any information, including your personal data, which
                          you specifically elect to make publicly available will
                          be available to other Members or the public. If you
                          remove information that you have made public,
                          copies/data may remain viewable in cached and archived
                          pages of PEDIAVERSE, or if other Members have copied
                          or saved that information.
                        </p>
                        <p>
                          If you no longer wish to receive these types of
                          communications, you turn them off at the device level.
                          Thus, in order to receive proper notifications, we
                          will need to collect certain information about your
                          device such as operating system and user
                          identification information.
                        </p>
                        <p>
                          The data provided by you may be changed and/or altered
                          and/or edited as per your requirement as and when
                          required by you. However, a specific request shall be
                          made by you for the same. Further, you may note that
                          we may be permitted or required (by law or otherwise)
                          to keep your information/data intact and not delete or
                          change it (or to keep this information for a certain
                          time, in which case we will comply with your deletion
                          request only after we have fulfilled such
                          requirements). If you request deletion, subject to our
                          rights to retain the Personal Data as set out in this
                          Privacy Policy, we will respond to your request within
                          1 month or more subject to any legal requirement(s).
                          We will retain your information for as long as your
                          account is active or as needed to provide you
                          services. We will retain and use your information as
                          necessary to comply with our legal obligations,
                          resolve disputes and enforce our agreements.
                        </p>
                        <Box id="el10" className="title">
                          <h4>J. BLOG / FORUM</h4>
                        </Box>
                        <p>
                          The Website as well as applications of PEDIAVERSE may
                          offer publicly accessible blogs or community forums.
                        </p>
                        <p>
                          You should be aware that any information you provide
                          in these areas may be read, collected, and used by
                          others who access them, as well as by our third party
                          service providers such as Open AI, L.L.C., to ensure
                          compliance with our Acceptable Use Policy and Content
                          Standards through our Enforcement Policy.{" "}
                        </p>
                        <p>
                          To request removal of your Personal Data from our blog
                          or community forum, you would have to raise a specific
                          request for the same to PEDIAVERSE.
                        </p>
                        <p>
                          In some cases, PEDIAVERSE may not be able to remove
                          your Personal Data, which shall be communicated to you
                          along with reasons.
                        </p>
                        <Box id="el11" className="title">
                          <h4>
                            K. SECURITY OF YOUR APPLICATION AND PERSONAL DATA
                          </h4>
                        </Box>
                        <p>
                          We are committed to protect and secure your Personal
                          Data.
                        </p>
                        <p>
                          PEDIAVERSE uses varied industry-standard security
                          technologies and procedures to help protect your data
                          from unauthorized access, use, or disclosure.
                          Therefore, whenever any sensitive information in
                          entered and/or used by you (such as a credit card
                          number, debit card details, identity details including
                          pictures, photos, etc.) the same is encrypted using
                          varied technologies.
                        </p>
                        <p>
                          You are thus required to enter your password and/or
                          other sign-on mechanism to access your account
                          information. Such details should not be shared and/or
                          disclosed by you to any third parties or with
                          unauthorized people.
                        </p>
                        <p>
                          However, you are well aware that, PEDIAVERSE would not
                          be able to fully eliminate security risks associated
                          with Personal Data.
                        </p>
                        <Box id="el12" className="title">
                          <h4>L. OVERSEAS DISCLOSURE OF YOUR DATA</h4>
                        </Box>
                        <p>
                          Unless and until it has been specifically stated by
                          you, we may host, transfer, and process data,
                          including personal data in other countries through our
                          website or our applications.
                        </p>
                        <p>
                          These countries may have data protection laws that are
                          different from those of your country of residence
                          which is well within your knowledge and you accept the
                          same.
                        </p>
                        <p>
                          PEDIAVERSE would take appropriate measures to ensure
                          such transfers are in compliance with applicable laws
                          of those countries.
                        </p>
                        <Box id="el13" className="title">
                          <h4>M. DATA RETENTION</h4>
                        </Box>
                        <p>
                          Other than in aggregated or de-identified form as
                          permitted under the terms and except as required by
                          applicable law, we will delete or otherwise destroy
                          your personal data as soon as practicably possible
                          following your termination or cancellation of your use
                          of our services.
                        </p>
                        <p>
                          PEDIAVERSE will retain and use this information as
                          necessary to comply with our legal obligations,
                          resolve disputes, and enforce our agreements.
                        </p>
                        <p>
                          PEDIAVERSE ensures that your personal data disposed of
                          is de-identified or destroyed in a secure fashion.
                        </p>
                        <Box id="el14" className="title">
                          <h4>N. JURISDICTION AND GOVERNING LAWS</h4>
                        </Box>
                        <p>
                          The Hon’ble Courts located at Ahmedabad shall have the
                          jurisdiction on any and/or all matters arising out of
                          the dispute(s) concerning to the adherence to the
                          terms and conditions and the breach thereof.
                        </p>
                        <p>
                          The terms and conditions as mentioned under this
                          Privacy Policy document shall be construed and
                          enforced according to the laws prevailing in India
                          including the amendments made thereto.
                        </p>
                        <Box id="el15" className="title">
                          <h4>O. PERSONAL INFORMATION OF MINORS</h4>
                        </Box>
                        <p>
                          The services provided by PEDIAVERSE over their website
                          as well as applications are not intended for children
                          or minors under the age of 18 years old under any set
                          of circumstances.
                        </p>
                        <p>
                          No kind of information and/or data is thus either
                          collected, stored and/or sold by PEDIAVERSE about
                          minors under the age of 18.
                        </p>
                        <p>
                          In case you believe that PEDIAVERSE has
                          unintentionally received personal information/data
                          about a minor under the age of 18 years old, your are
                          requested to immediately contact us through any means
                          of communication so that corrective actions may be
                          initiated by PEDIAVERSE at the earliest date possible.
                        </p>
                        <Box id="el16" className="title">
                          <h4>P. SALE OF PERSONAL INFORMATION</h4>
                        </Box>
                        <p>
                          PEDIAVERSE does not engage in any activity either
                          directly and/or indirectly wherein your personal
                          information is sold to third parties against any
                          monetary amounts.
                        </p>
                        <p>
                          The same applies to the personal information of minors
                          under the age of 16 or 18 as the case may be; if any.
                        </p>
                        <Box id="el17" className="title">
                          <h4>Q. QUERIES, CONCERNS, AND COMPLAINTS</h4>
                        </Box>
                        <p>
                          We value your queries, concerns, feedbacks and
                          conplaints.
                        </p>
                        <p>
                          In case of any queries, concerns or complaints about
                          the manner in which we have collected, stored, used or
                          disclosed your personal information, you are requested
                          to contact our concerned Administrative Head over the
                          email.
                        </p>
                        <p>Your complaint shall be treated confidentially.</p>
                        <p>
                          Any and/or all ways for resolving your complaint shall
                          be discussed so as to provide you with the speediest
                          remedy possible by PEDIAVERSE.
                        </p>
                        <p>
                          PEDIAVERSE will ensure that your complaint is resolved
                          within a reasonable time (and in any event within the
                          time required by applicable law).
                        </p>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </>
          )}
        </Toolbar>

        {matches ? (
          <Box sx={{ minHeight: "100vh" }}>
            <SwipeableDrawer
              anchor="left"
              open={state["left"]}
              onClose={toggleDrawer("left", false)}
              onOpen={toggleDrawer("left", true)}
            >
              {list("left")}
            </SwipeableDrawer>
            <Box className="terms-and-conditions-right-side">
              <Box className="title-bottom-border">
                <h1>Terms of Service</h1>
              </Box>
              <Box sx={{ paddingTop: "30px" }}>
                Effective from - Sep 19, 2023
              </Box>
              <Box>
                <p>
                  The privacy policy is based on all the products/services that
                  are being provided and dealt with by PEDIAVERSE to their
                  existing customers. However the same shall also be applicable
                  for any and/or all the products/services that are provided to
                  the customers of PEDIAVERSE in the future based on the
                  development, software updates, market trends, etc.
                </p>
                <p>
                  You are therefore required to go through all the terms and
                  conditions as mentioned hereunder based on which you may make
                  your decision to continue or discontinue your venture with
                  PEDIAVERSE. Upon acceptance of the said document it shall be
                  understood by PEDIAVERSE that you have unconditionally
                  accepted any and/or all the terms and conditions as mentioned
                  hereunder and that you have and shall not raise any
                  contradiction, legal issues, questions, queries, etc. about
                  the same for all points of time in the future and that
                  PEDIAVERSE shall not be liable under any set of circumstances
                  either to you and/or your subordinates, sister companies,
                  third parties associated with your, either directly and/or
                  indirectly for any amounts including any charges, fees,
                  payments, duties, costs, etc. Further, it must be clearly
                  noted, understood and accepted by you that upon breach of any
                  of the terms and conditions as mentioned hereunder PEDIAVERSE
                  shall have any and/or all the legal right(s) to be initiated
                  against you personally or your organization and/or any other
                  person(s) either associated and/or connected with you either
                  directly and/or indirectly and that such persons shall be
                  jointly and severally be liable for the costs and consequences
                  arising out of such legal actions which may be in the form of
                  Civil and/or Criminal remedies including the costs, expenses
                  as well as lawyer’s fees; which may be clearly understood by
                  you.
                </p>
                <p>The terms and conditions as mentioned as follows:</p>
                <Box id="el1" className="title">
                  <h4>A. BASIC TERMS</h4>
                </Box>
                <p>
                  It will be your responsibility to ensure the security and
                  confidentiality of usernames and passwords which will be used
                  to access this website. Any breach, compromise or unauthorised
                  use should be immediately notified to PEDIAVERSE.
                </p>
                <p>
                  The security or integrity of the computing system, network and
                  the website of PEDIAVERSE shall not be compromised in any way
                  by you as well as the organisation in which you are
                  associated.
                </p>
                <p>
                  Must not use any form of abuse over the Website and/or
                  Applications or other software products of PEDIAVERSE in any
                  form or way that will adversely impact the functionality of
                  the website or the ability of any user to use the website of
                  PEDIAVERSE. No kind of any derogatory remarks shall be made by
                  you as mentioned above.
                </p>
                <p>
                  Any type of activity resulting in unauthorized access to the
                  computer system on server of the website or to any materials
                  other than those to which access or permission has been
                  granted will amount to a violation or a breach of the policy.
                </p>
                <p>
                  Any type of act resulting in transmission of files, contents
                  that may be offensive, materials, data in violation of any
                  laws of the land (included materials protected by copyright or
                  trade secrets which restricts the right to use it) in the
                  website, damaging any other person’s computing devices or
                  software will be amount to a violation or a breach of the
                  policy.
                </p>
                <p>
                  Any act resulting in modifying, copying, adapting, editing,
                  reproducing, disassembling, decompiling or reverse engineering
                  the website or the applications of the Company, except as is
                  strictly necessary to use for formal operation will be
                  regarded as a violation or a breach of the policy.
                </p>
                <p>
                  The website of the Company; i.e. PEDIAVERSE; should be
                  accessed manually. Any act resulting into usage of automated
                  agents, software other than the search engine to view the
                  website is forbidden
                </p>
                <p>
                  If you use any communication tools available through the
                  Website of the Company such as Blogs, support portals,
                  messaging centre, you unconditionally agree to use such
                  communication tools for lawful and legitimate purposes only.
                  You must not use these tools to post offensive content, any
                  material in violation of intellectual property rights or any
                  offers of goods or services for sale.
                </p>

                <Box id="el2" className="title">
                  <h4>B. INTELLECTUAL PROPERTY RIGHTS</h4>
                </Box>
                <p>
                  The Intellectual Property Rights in all the constituents
                  comprising the website including the structure, design &layout
                  including graphical images along with the applied source codes
                  vests with PEDIAVERSE.
                </p>
                <p>
                  It is recognized that all the Intellectual Property Rights of
                  PEDIAVERSE portal, the website as well as all the computer
                  aided or mobile aided applications; shall vest with
                  PEDIAVERSE.
                </p>
                <p>
                  No kind of any royalty-free, perpetual, irrevocable,
                  non-exclusive right and license is granted to any of the
                  Customers to use, reproduce, modify, adapt, publish,
                  translate, create, derivative work from, distribute,
                  communicate, perform and display the content, in whole or in
                  part, worldwide and to incorporate it in other works in any
                  form, media or technology knows or later developed for full
                  term of any rights that may exist by submitting any blogs,
                  messages boards or forums of PEDIAVERSE.
                </p>
                <p>
                  You shall not provide any content to PEDIAVERSE that does not
                  belong to you or if you do not have the intellectual property
                  rights for that content.
                </p>
                <p>
                  Building or Copying or encrypting any of the data PEDIAVERSE
                  will be a breach of our intellectual property.
                </p>
                <Box id="el3" className="title">
                  <h4>C. DISCLAIMERS AND WARRANTIES</h4>
                </Box>
                <p>You fully acknowledge to the Company the following:</p>
                <p>That you are authorised to access and use the Website.</p>
                <p>
                  That in case you are using the website on behalf of any
                  organization, you would still be liable for your actions along
                  with the organization for any breach of terms.
                </p>
                <p>
                  The provision of, access to, and use of, the Website is on an
                  “as is, where is” basis and at your own risk.
                </p>
                <p>
                  t is not guaranteed that the website or the applications of
                  PEDIAVERSE will be error free and that PEDIAVERSE will not be
                  responsible for any disruptions caused due to any
                  applications, gadgets including internet services used by
                  yourself to access the website. No kind of damages and/or
                  losses shall be cast upon PEDIAVERSE based on the
                  non-performance of any of their websites and/or applications
                  for any reasons of whatsoever nature.
                </p>
                <p>
                  It shall be your sole responsibility to determine that the
                  Website or the applications of PEDIAVERSE meets the needs of
                  your business. No kind of repayment and/or refund shall be
                  made by PEDIAVERSE under any set of circumstances, reasons,
                  technical hitches, etc. of whatsoever nature which may be
                  claimed by you.
                </p>
                <p>
                  Without limiting the foregoing, PEDIAVERSE does not warrant
                  that their Website as well as their applications will meet
                  your requirements or that it will be suitable for your
                  purposes.{" "}
                </p>
                <p>
                  To avoid doubt, all implied conditions or warranties are
                  excluded in so far as is permitted by law including, without
                  limitation, warranties of merchantability, fitness for
                  purpose, title and non-infringement.
                </p>
                <Box id="el4" className="title">
                  <h4>D. PERFORMANCE OF THE WEBSITE AND APPLICATIONS</h4>
                </Box>
                <p>
                  PEDIAVERSE denies all liability for the timely operation of
                  the Website or any of its applications when used within an
                  Internet environment, where you or a third party is providing
                  the computer equipment upon which the product is to reside or
                  depend upon for any part of its functionality.
                </p>
                <p>
                  By accepting these Terms you confirm your understanding that
                  the timely operation of the Internet and the World Wide Web is
                  governed by constraints beyond the control of PEDIAVERSE and
                  that it is not liable for the perceived slow operation of the
                  Website or any of its applications.
                </p>
                <p>
                  The client must maintain a copy of all their data inputted
                  into the website or the applications of PEDIAVERSE who
                  although shall take a regular backup of all the data but
                  however does not guarantee that there will no loss of data.
                  PEDIAVERSE excludes liability for any loss of data no matter
                  how it was caused.
                </p>
                <p>
                  To the maximum extent permitted by law, PEDIAVERSE excludes
                  all liability and responsibility to you (or any other person)
                  in contract, tort (including negligence), or otherwise, for
                  any loss (including loss of information, Data, profits and
                  savings) or damage resulting, directly or indirectly, from any
                  use of, or reliance on, the Service or Website or
                  applications.
                </p>
                <Box id="el5" className="title">
                  <h4>E. THIRD PARTY LINKS</h4>
                </Box>
                <p>
                  This Privacy Policy applies only to the use and disclosure of
                  Personal Data that is collected by PEDIAVERSE.
                </p>
                <p>
                  Provision of a link to any other website or location is for
                  your convenience and does not signify our endorsement of such
                  other website or location or its contents.
                </p>
                <p>
                  When you click on such a link, you will leave the Services of
                  PEDIAVERSE available on wither its website and/or its
                  applications and would go to another site. During this
                  process, a third party may collect Personal Data from you.
                  PEDIAVERSE has no control over, dose not review, dose not
                  endorse, and cannot be responsible for, these outside websites
                  or their content.
                </p>
                <p>
                  You may thus be fully aware that the terms of this Privacy
                  Policy do not apply to these outside websites or content, or
                  to any collection of data after you click on a link to a third
                  party. In case of submission of any Personal Data by you to
                  any of those sites, your information is governed by their
                  privacy policies.
                </p>
                <Box id="el6" className="title">
                  <h4>F. COOKIE POLICY AND USE OF TRACKING</h4>
                </Box>
                <p>
                  Upon any interaction over the Website or the Applications of
                  PEDIAVERSE, an effort is made for accessing and using the same
                  in a simple manner by PEDIAVERSE so that the contents
                  mentioned therein are easily understood by the
                  Client/Customer.
                </p>
                <p>
                  PEDIAVERSE as well as other such organizations use industry
                  standard identifiers, such as cookies or other similar
                  technologies wherein the term cookies, web beacons, flash
                  cookies and pixels would be collectively referred as
                  “cookies”, “tracking technology” or “identifiers” in this
                  policy. By using our Services, you are unconditionally
                  agreeing that PEDIAVERSE can use cookies and other tracking
                  technologies described in this Cookie Policy.
                </p>
                <Box id="el7" className="title">
                  <h4>G. NOTICE FOR TERMINATION AND REMEDIES</h4>
                </Box>
                <p>
                  PEDIAVERSE reserves the right to cancel your contract or
                  restrict your access to any of the websites as well as
                  applications of PEDIAVERSE without any prior notice in any
                  unlikely event of a breach of this contract.
                </p>
                <p>
                  In case of any legal dispute PEDIAVERSE shall be entitled to
                  share your user details, data, passwords, identity and/or any
                  other information; if requested by the court or any other law
                  enforcement authorities or agencies.
                </p>
                <p>
                  Your data will be retained on our database for period of 90
                  days from the expiry date of your subscription. After this
                  time period all your data will be purged from the database of
                  PEDIAVERSE.
                </p>
                <p>
                  Noncompliance with any of the terms and conditions as
                  mentioned hereinabove shall lead to an immediate termination
                  of the services from either of the parties to the other.
                  However, in case where an error and/or dispute can be
                  resolved, a prior intimation for the same shall be sent by the
                  party affected to the other who shall try to resolve the same
                  at the immediate and earliest possible date and to the best of
                  their abilities. Such intimation can be given by the party
                  affected to the other over the email and/or through a
                  registered post only. No kind of intimation over any of the
                  communicating applications shall be valid.
                </p>
                <p>
                  If you are not satisfied with the Services of PEDIAVERSE, your
                  sole and exclusive remedy is to terminate these Terms.
                </p>
                <Box id="el8" className="title">
                  <h4>H. WAIVER AND ENFORCEABILITY</h4>
                </Box>
                <p>
                  Any failure or delay by PEDIAVERSE to enforce any of the terms
                  or to exercise any right under the terms will not be
                  considered as a waiver to any extent of any other rights as
                  per the Law that are available to PEDIAVERSE.
                </p>
                <p>
                  If either party waives any breach of these terms in entire
                  agreement, this will not constitute a waiver of any other
                  breach. No waiver will be effective unless made in writing.
                </p>
                <Box id="el9" className="title">
                  <h4>I. USAGE OF PERSONAL DATA</h4>
                </Box>
                <p>
                  The data used, shared, transferred or downloaded by the Client
                  shall be used by PEDIAVERSE in the following manner:
                </p>
                <p>
                  For creating your account on our network and securing the same
                  and to recognise your identity.
                </p>
                <p>
                  For administering and improving the services provided by
                  PEDIAVERSE including updates, advertisements, email
                  communications, chat and its notifications, security and
                  support, payment gateways, resolution of issues, bugs, errors,
                  interactive interface, surveys, events or promotions, data
                  analysis, notices, changes as well as updatation in the terms
                  of the Policy legal processes, discontinuation of services,
                  etc..
                </p>
                <p>
                  For prevention of any unlawful, unethical, illegally
                  actionable and/or fraudulent activity.
                </p>
                <p>
                  For monitoring and enforcement of compliance with the
                  applicable Terms of mentioned in the Policy document.
                </p>
                <p>
                  The feedback provided by you would be stored, analysed,
                  discussed and used for our internal administration in order to
                  further assist you in providing our services through our
                  website as well as applications.
                </p>
                <p>
                  Any information, including your personal data, which you
                  specifically elect to make publicly available will be
                  available to other Members or the public. If you remove
                  information that you have made public, copies/data may remain
                  viewable in cached and archived pages of PEDIAVERSE, or if
                  other Members have copied or saved that information.
                </p>
                <p>
                  If you no longer wish to receive these types of
                  communications, you turn them off at the device level. Thus,
                  in order to receive proper notifications, we will need to
                  collect certain information about your device such as
                  operating system and user identification information.
                </p>
                <p>
                  The data provided by you may be changed and/or altered and/or
                  edited as per your requirement as and when required by you.
                  However, a specific request shall be made by you for the same.
                  Further, you may note that we may be permitted or required (by
                  law or otherwise) to keep your information/data intact and not
                  delete or change it (or to keep this information for a certain
                  time, in which case we will comply with your deletion request
                  only after we have fulfilled such requirements). If you
                  request deletion, subject to our rights to retain the Personal
                  Data as set out in this Privacy Policy, we will respond to
                  your request within 1 month or more subject to any legal
                  requirement(s). We will retain your information for as long as
                  your account is active or as needed to provide you services.
                  We will retain and use your information as necessary to comply
                  with our legal obligations, resolve disputes and enforce our
                  agreements.
                </p>
                <Box id="el10" className="title">
                  <h4>J. BLOG / FORUM</h4>
                </Box>
                <p>
                  The Website as well as applications of PEDIAVERSE may offer
                  publicly accessible blogs or community forums.
                </p>
                <p>
                  You should be aware that any information you provide in these
                  areas may be read, collected, and used by others who access
                  them, as well as by our third party service providers such as
                  Open AI, L.L.C., to ensure compliance with our Acceptable Use
                  Policy and Content Standards through our Enforcement
                  Policy.{" "}
                </p>
                <p>
                  To request removal of your Personal Data from our blog or
                  community forum, you would have to raise a specific request
                  for the same to PEDIAVERSE.
                </p>
                <p>
                  In some cases, PEDIAVERSE may not be able to remove your
                  Personal Data, which shall be communicated to you along with
                  reasons.
                </p>
                <Box id="el11" className="title">
                  <h4>K. SECURITY OF YOUR APPLICATION AND PERSONAL DATA</h4>
                </Box>
                <p>
                  We are committed to protect and secure your Personal Data.
                </p>
                <p>
                  PEDIAVERSE uses varied industry-standard security technologies
                  and procedures to help protect your data from unauthorized
                  access, use, or disclosure. Therefore, whenever any sensitive
                  information in entered and/or used by you (such as a credit
                  card number, debit card details, identity details including
                  pictures, photos, etc.) the same is encrypted using varied
                  technologies.
                </p>
                <p>
                  You are thus required to enter your password and/or other
                  sign-on mechanism to access your account information. Such
                  details should not be shared and/or disclosed by you to any
                  third parties or with unauthorized people.
                </p>
                <p>
                  However, you are well aware that, PEDIAVERSE would not be able
                  to fully eliminate security risks associated with Personal
                  Data.
                </p>
                <Box id="el12" className="title">
                  <h4>L. OVERSEAS DISCLOSURE OF YOUR DATA</h4>
                </Box>
                <p>
                  Unless and until it has been specifically stated by you, we
                  may host, transfer, and process data, including personal data
                  in other countries through our website or our applications.
                </p>
                <p>
                  These countries may have data protection laws that are
                  different from those of your country of residence which is
                  well within your knowledge and you accept the same.
                </p>
                <p>
                  PEDIAVERSE would take appropriate measures to ensure such
                  transfers are in compliance with applicable laws of those
                  countries.
                </p>
                <Box id="el13" className="title">
                  <h4>M. DATA RETENTION</h4>
                </Box>
                <p>
                  Other than in aggregated or de-identified form as permitted
                  under the terms and except as required by applicable law, we
                  will delete or otherwise destroy your personal data as soon as
                  practicably possible following your termination or
                  cancellation of your use of our services.
                </p>
                <p>
                  PEDIAVERSE will retain and use this information as necessary
                  to comply with our legal obligations, resolve disputes, and
                  enforce our agreements.
                </p>
                <p>
                  PEDIAVERSE ensures that your personal data disposed of is
                  de-identified or destroyed in a secure fashion.
                </p>
                <Box id="el14" className="title">
                  <h4>N. JURISDICTION AND GOVERNING LAWS</h4>
                </Box>
                <p>
                  The Hon’ble Courts located at Ahmedabad shall have the
                  jurisdiction on any and/or all matters arising out of the
                  dispute(s) concerning to the adherence to the terms and
                  conditions and the breach thereof.
                </p>
                <p>
                  The terms and conditions as mentioned under this Privacy
                  Policy document shall be construed and enforced according to
                  the laws prevailing in India including the amendments made
                  thereto.
                </p>
                <Box id="el15" className="title">
                  <h4>O. PERSONAL INFORMATION OF MINORS</h4>
                </Box>
                <p>
                  The services provided by PEDIAVERSE over their website as well
                  as applications are not intended for children or minors under
                  the age of 18 years old under any set of circumstances.
                </p>
                <p>
                  No kind of information and/or data is thus either collected,
                  stored and/or sold by PEDIAVERSE about minors under the age of
                  18.
                </p>
                <p>
                  In case you believe that PEDIAVERSE has unintentionally
                  received personal information/data about a minor under the age
                  of 18 years old, your are requested to immediately contact us
                  through any means of communication so that corrective actions
                  may be initiated by PEDIAVERSE at the earliest date possible.
                </p>
                <Box id="el16" className="title">
                  <h4>P. SALE OF PERSONAL INFORMATION</h4>
                </Box>
                <p>
                  PEDIAVERSE does not engage in any activity either directly
                  and/or indirectly wherein your personal information is sold to
                  third parties against any monetary amounts.
                </p>
                <p>
                  The same applies to the personal information of minors under
                  the age of 16 or 18 as the case may be; if any.
                </p>
                <Box id="el17" className="title">
                  <h4>Q. QUERIES, CONCERNS, AND COMPLAINTS</h4>
                </Box>
                <p>
                  We value your queries, concerns, feedbacks and conplaints.
                </p>
                <p>
                  In case of any queries, concerns or complaints about the
                  manner in which we have collected, stored, used or disclosed
                  your personal information, you are requested to contact our
                  concerned Administrative Head over the email.
                </p>
                <p>Your complaint shall be treated confidentially.</p>
                <p>
                  Any and/or all ways for resolving your complaint shall be
                  discussed so as to provide you with the speediest remedy
                  possible by PEDIAVERSE.
                </p>
                <p>
                  PEDIAVERSE will ensure that your complaint is resolved within
                  a reasonable time (and in any event within the time required
                  by applicable law).
                </p>
              </Box>
            </Box>

            {/* <Box sx={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginX: '16px !important',
                            marginBottom: '16px !important',
                            flexDirection: smallScreen ? 'column' : 'row'
                        }}>
                            <Typography className="font-size-11">Copyrights &copy; {new Date().getFullYear()} - PEDIAVERSE SOLUTIONS PRIVATE LIMITED<sup>&#xae;</sup> Biz</Typography>
                            <Typography className="font-size-11"><a href="/terms" target="_blank" style={{ textDecoration: 'none' }} className="blue-link">Terms of Service</a> &nbsp; <a href="/privacy-policy" target="_blank" style={{ textDecoration: 'none' }} className="blue-link">Privacy Policy</a></Typography>
                        </Box> */}
          </Box>
        ) : (
          <></>
        )}
      </AppBar>
    </Box>
  );
}
